export default __webpack_public_path__ + "static/media/schools_exams.96934295.png";